import React from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { Assessment4Model } from "../state";


interface Assessment4DownloadCSVProps {
    model: Assessment4Model;
}

function Assessment4DownloadCSV({ model }: Assessment4DownloadCSVProps) {
    const csvData = [["Issue", "Action Plan"]];
    let rowIndex:number = 1;
    if(model.trackAcctNoFormatDesc !== null && model.trackAcctNoFormatDesc !== '')
    {
        csvData[rowIndex] = ["Checking that all account numbers follow the correct format for each vendor."
                              , model.trackAcctNoFormatDesc];
        rowIndex++; 
    }
    if(model.trackPctHHAcctNoDesc !== null && model.trackPctHHAcctNoDesc !== '')
    {
        csvData[rowIndex] = ["Tracking the percentage of your assisted households that have an electric vendor and account number listed in their file."
                              , model.trackPctHHAcctNoDesc];
        rowIndex++; 
    }
    if(model.trackMissingAcctNoCertainAgenciesDesc !== null && model.trackMissingAcctNoCertainAgenciesDesc !== '')
    {
        csvData[rowIndex] = ["Tracking the number of assisted households that are missing an electric vendor or account number by agency and vendor. "
                              , model.trackMissingAcctNoCertainAgenciesDesc];
        rowIndex++; 
    }
    if(model.trackPctHHVendorNotFindDesc !== null && model.trackPctHHVendorNotFindDesc !== '')
    {
        csvData[rowIndex] = ["Tracking the percentage of your assisted households for whom vendors cannot find accounts in the vendor system."
                              , model.trackPctHHVendorNotFindDesc];
        rowIndex++; 
    }
    if(model.trackNotFindCertainAgenciesDesc !== null && model.trackNotFindCertainAgenciesDesc !== '')
    {
        csvData[rowIndex] = ["Tracking clients not found in vendor system by agency and vendor."
                              , model.trackNotFindCertainAgenciesDesc];
        rowIndex++; 
    }
    if(model.processIdentifyLargestElectricVendorsDesc !== null && model.processIdentifyLargestElectricVendorsDesc !== '')
    {
        csvData[rowIndex] = ["Identifying the electric vendors in your state who serve the largest number of clients."
                              , model.processIdentifyLargestElectricVendorsDesc];
        rowIndex++; 
    }
    if(model.processChooseVendorsBaseDiffHeatDesc !== null && model.processChooseVendorsBaseDiffHeatDesc !== '')
    {
        csvData[rowIndex] = ["Choosing vendors if the largest main heating suppliers are different than the largest baseload suppliers."
                              , model.processChooseVendorsBaseDiffHeatDesc];
        rowIndex++; 
    }
    if(model.processTrackVendorComplianceDesc !== null && model.processTrackVendorComplianceDesc !== '')
    {
        csvData[rowIndex] = ["Tracking whether electric vendors have supplied data in the past when requested."
                              , model.processTrackVendorComplianceDesc];
        rowIndex++; 
    }
    if(model.trackVendorDataCompleteDesc !== null && model.trackVendorDataCompleteDesc !== '')
    {
        csvData[rowIndex] = ["Tracking whether electric vendors supply complete data (e.g. twelve months of complete billing."
                              , model.trackVendorDataCompleteDesc];
        rowIndex++; 
    }
    if(model.useTrackingToSelectVendorsDesc !== null && model.useTrackingToSelectVendorsDesc !== '')
    {
        csvData[rowIndex] = ["Tracking process to determine from which electric vendors to request data on electric expenditures."
                              , model.useTrackingToSelectVendorsDesc];
        rowIndex++; 
    }
    if(model.excludeHhNot12MonthsDataDesc !== null && model.excludeHhNot12MonthsDataDesc !== '')
    {
        csvData[rowIndex] = ["Ensure that households are excluded from the dataset if they have some electric baseload data but not a full 12 months."
                              , model.excludeHhNot12MonthsDataDesc];
        rowIndex++; 
    }
    if(model.checkAndReportOutliersDesc !== null && model.checkAndReportOutliersDesc !== '')
    {
        csvData[rowIndex] = ["Check the range of electric Baseload fuel bills reported by vendors and investigate the high and low outliers."
                              , model.checkAndReportOutliersDesc];
        rowIndex++; 
    }
    if(model.processReviewFindingsDesc !== null && model.processReviewFindingsDesc !== '')
    {
        csvData[rowIndex] = ["Procedures in place for reviewing and resolving the findings from each check."
                              , model.processReviewFindingsDesc];
        rowIndex++; 
    }
    if(model.processAddChecksDesc !== null && model.processAddChecksDesc !== '')
    {
        csvData[rowIndex] = ["System in place to add checks when new problems arise."
                              , model.processAddChecksDesc];
        rowIndex++; 
    }
    if(model.processRemoveChecksDesc !== null && model.processRemoveChecksDesc !== '')
    {
        csvData[rowIndex] = ["System in place for removing checks that generate high false positive rates."
                              , model.processRemoveChecksDesc];
        rowIndex++; 
    }

    return (
      <CSVLink data={csvData} filename="ElectricBaseloadAssessment4.csv" className="dataButton">Download as CSV</CSVLink>
    );
}


export default Assessment4DownloadCSV;
